<div class="container">
    <div class="title-container">
        <h4 class="mat-title" *ngIf="!isEditing">Ajout d'une négociation non garantie</h4>
        <h4 class="mat-title" *ngIf="isEditing && !data.isDuplication">Modification d'une négociation non garantie</h4>
        <h4 class="mat-title" *ngIf="isEditing && data.isDuplication">Duplication d'une négociation non garantie</h4>
    </div>

    <ng-container *ngIf="!isSaving; else savingContentTemplate">
        <div class="tv-ns-custom-horizontal-divider"></div>

        <div class="bloc-container">
            <h4 class="red-title">Général</h4>
            <div class="inputs-container inputs-container-top">

                <!-- Date Range -->
                <custom-date-range-picker
                        [ngModel]="{ start: negotiationDateForm.get('startDate')?.value, end: negotiationDateForm.get('endDate')?.value }"
                        [ngModelOptions]="{ standalone: true }"
                        (ngModelChange)="negotiationDateForm.patchValue({ startDate: $event ? $event.start : null, endDate: $event ? $event.end : null })"
                        [min]="negotiationDateForm.get('startDate')?.value"
                        [max]="negotiationDateForm.get('endDate')?.value"
                        [styleType]="'squared'"
                        valueFormat="dd/MM/yyyy"
                        [required]="true">
                </custom-date-range-picker>

                <!-- CA in €  -->
                <div class="tv-rect-input-extensible width-180px">
                    <mat-form-field>
                        <mat-label>Coût GRP €</mat-label>
                        <input type="number"
                               matInput
                               [formControl]="budgetFormControl">
                    </mat-form-field>
                    <div class="tv-input-error-message"
                         *ngIf="budgetFormControl.touched && budgetFormControl.hasError('required')">
                        <mat-icon class="tv-input-error-icon">error</mat-icon>
                        <span class="tv-input-error-text">Veuillez renseigner une valeur</span>
                    </div>
                    <div class="tv-input-error-message"
                         *ngIf="budgetFormControl.touched && budgetFormControl.hasError('min')">
                        <mat-icon class="tv-input-error-icon">error</mat-icon>
                        <span class="tv-input-error-text">Supérieure à égale 0</span>
                    </div>
                </div>

                <!-- NCT Rate  -->
                <div class="tv-rect-input-extensible width-180px">
                    <mat-form-field>
                        <mat-label>taux NCT %</mat-label>
                        <input type="number"
                               matInput
                               [formControl]="nctRateFormControl"
                               (blur)="enforceNegativeNctRate()">
                    </mat-form-field>
                    <div class="tv-input-error-message"
                         *ngIf="nctRateFormControl.touched && nctRateFormControl.hasError('required')">
                        <mat-icon class="tv-input-error-icon">error</mat-icon>
                        <span class="tv-input-error-text">Veuillez renseigner une valeur</span>
                    </div>
                    <div class="tv-input-error-message"
                         *ngIf="nctRateFormControl.touched && (nctRateFormControl.hasError('min') || nctRateFormControl.hasError('max'))">
                        <mat-icon class="tv-input-error-icon">error</mat-icon>
                        <span class="tv-input-error-text">Compris entre -999 et 0</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="bloc-container-row-60-percent">
            <!-- Chaines -->
            <div class="bloc-container-channel">
                <h4 class="red-title">Chaines</h4>
                <div class="inputs-container">
                    <!-- Search Item -->
                    <div class="tv-rect-input-extensible flex-auto">
                        <mat-form-field>
                            <mat-label>Rechercher</mat-label>
                            <input
                                    class="tv-ns-select-option"
                                    matInput
                                    type="text"
                                    aria-label="Number"
                                    [formControl]="searchChannelFormControl"
                                    [matAutocomplete]="channelAuto"
                            >
                            <mat-autocomplete autoActiveFirstOption class="tv-custom-always-visible-scroll-bar"
                                              #channelAuto="matAutocomplete"
                                              [displayWith]="displayChannel">
                                <mat-option *ngFor="let channel of filteredChannelList$ | async"
                                            class="tv-ns-select-option"
                                            [value]="channel">
                                    <img *ngIf="channel" [src]="channel.logo" alt="{{ channel.name }}-logo"
                                         class="channel-logo"/>
                                    <span *ngIf="channel" class="channel-name">{{ channel.name }}</span>

                                </mat-option>
                            </mat-autocomplete>
                        </mat-form-field>
                    </div>
                </div>

            </div>

            <!-- Repartition -->
            <div class="bloc-container-share">
                <div class="red-title-container">
                    <h4 class="red-title">Répartition : </h4>
                    <div class="red-info-container">
                    </div>
                </div>
                <ng-container>
                    <div
                            class="container-chips tv-custom-scroll-bar lateral-padding-l"
                            *ngIf="selectedChannel"
                    >
                        <div class="block-chip">
                            <img class="channel-logo" src="{{ selectedChannel?.logo }}" alt="logo"/>
                            <span> {{ selectedChannel?.name }} </span>
                            <mat-icon (click)="removeChannelItem(selectedChannel)">cancel</mat-icon>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>

        <div class="button-edit">
            <button class="tv-ns-secondary-large-button-on-light-bg" (click)="onCancelUpdateButtonClick()">Annuler
            </button>
            <button class="tv-ns-validation-large-button" (click)="onValidationButtonClick()">Valider
            </button>
        </div>
    </ng-container>
    <ng-template #savingContentTemplate>
        <div class="saving-content">
            <mat-spinner diameter="30" class="light-spinner"></mat-spinner>
        </div>
    </ng-template>
</div>
